/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  





//   =========================================================
//   -------- Custom code ------
//     Syncs Recharge selected plan price with:
//     - Main Add To Cart button price
//     - Sticky Cart Bar price
//     Keeps Shopify theme pricing updated when Recharge options change.
//   =========================================================

  document.addEventListener('DOMContentLoaded', function () {
    function updateATCPrice() {
      try {
        const widget = document.querySelector('recharge-subscription-widget');
        if (!widget || !widget.shadowRoot) return;

        const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
        if (!upsell || !upsell.shadowRoot) return;

        const root = upsell.shadowRoot;

        const selectedInput = root.querySelector('input[name="quantityUpsellOption"]:checked');
        if (!selectedInput) return;

        const option = selectedInput.closest('.rc-quantity-upsell-option');
        if (!option) return;
 

        const totalPriceEl = option.querySelector('.rc-custom-total-price');
        // const comparePriceEl = option.querySelector('.rc-custom-compare-price');
        const comparePriceEl = option.querySelector('.rc-custom-total-compare-price');


        const finalPrice = totalPriceEl ? totalPriceEl.textContent.trim() : '';


        const comparePrice =
          comparePriceEl && comparePriceEl.style.display !== 'none'
            ? comparePriceEl.textContent.trim()
            : '';

        if (!finalPrice) return;

        const priceHTML = comparePrice
          ? `
            <span class="custom-atc-final-price">${finalPrice}</span>
            <span class="custom-atc-compare-price" style="text-decoration: line-through; opacity: 0.65; margin-left: 6px;">${comparePrice}</span>
          `
          : `<span class="custom-atc-final-price">${finalPrice}</span>`;

        /* =========================
           MAIN ADD TO CART BUTTON
        ========================= */

        const mainPrice = document.querySelector('.product__submit [data-product-price]');

        if (mainPrice) {
          mainPrice.innerHTML = priceHTML;
        }

        /* =========================
           STICKY CART BAR PRICE
        ========================= */

        const stickyPrice = document.querySelector('.cart-bar__product__price [data-product-price]');

        if (stickyPrice) {
          stickyPrice.innerHTML = priceHTML;
        }
      } catch (e) {
        return;
      }
    }

    function initRechargeObserver() {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget) return;

      const wait = setInterval(() => {
        if (!widget.shadowRoot) return;

        const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
        if (!upsell || !upsell.shadowRoot) return;

        clearInterval(wait);

        updateATCPrice();

        const observer = new MutationObserver(() => {
          requestAnimationFrame(updateATCPrice);
        });

        observer.observe(upsell.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });
      }, 200);
    }

    initRechargeObserver();

    setTimeout(updateATCPrice, 300);
    setTimeout(updateATCPrice, 1000);
    setTimeout(updateATCPrice, 2000);

    document.addEventListener('change', function () {
      setTimeout(updateATCPrice, 50);
      setTimeout(updateATCPrice, 200);
      setTimeout(updateATCPrice, 500);
    });
  });

 



//   =========================================================
//   -------- Custom code ------
//   Code fix for showing price per month and compare at price and 
//   removing margin from the recharge widget on PDP
//   =========================================================
(function () {
  const PRODUCT_VARIANT_ID = '43773480534109';

  function getPriceData() {
    return window.SubscriptionWidgetConfig?.formattedPrices?.[PRODUCT_VARIANT_ID];
  }

  function getRechargeRoots() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot) return {};
    const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!upsell?.shadowRoot) return {};
    return { upsellRoot: upsell.shadowRoot };
  }

  function injectRechargeCSS(root) {
    if (!root || root.querySelector('#custom-recharge-compare-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-recharge-compare-style';
    style.textContent = `
      .rc-custom-price-wrap {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-end !important;
        gap: 4px !important;
        white-space: nowrap !important;
      }

      .rc-custom-total-price,
      .rc-custom-total-compare-price {
        display: none !important;
      }

      .rc-custom-percent-badge {
        border-radius: 7px !important;
        padding: 7px 12px !important;
        font-size: 13px !important;
        line-height: 1.1 !important;
        font-weight: 600 !important;
      }

      .rc-custom-per-month-price {
        line-height: 1.2 !important;
        font-weight: 600 !important;
        font-size: 18px !important;
      }

      .rc-custom-compare-price {
        font-size: 12px !important;
        color: #888 !important;
        text-decoration: line-through !important;
        line-height: 1.1 !important;
        font-weight: 400 !important;
      }

      .rc-quantity-upsell-option[rc-not-selected] {
        border-color: lightgrey !important;
      }

      .rc-purchase-option__recommended-badge,
      .rc-purchase-option__best-value-badge {
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%) !important;
        
        color: #fff !important;
        
        padding: 0px 6px !important;
        border-radius: 4px !important;

        top: -10px !important;
        font-size:12px!important;
      }
      .rc-quantity-upsell-option__title {
      font-size: 20px !important;
      font-weight: 600 !important;
      line-height: 1.3 !important;
      }
      .rc-quantity-upsell-option__title .rc-purchase-option__plan-discount-badge {
        font-size: 12px !important;
      }
      .rc-purchase-option__plan-discount-badge {
        background: #82a6c2 !important;
        color: #ffffff !important;
        border: 1px solid #82a6c2 !important;
        border-radius:4px !important;
        
      }
      .rc-quantity-upsell-option__header > div:first-child {
        font-size: 20px !important;
      }
      
    `;
    root.appendChild(style);
  }

  function getNumber(price) {
    return parseFloat(String(price).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function getMonths(planId) {
    return planId === '4670062685' ? 3 : 1;
  }

  function injectBenefitsCSS(benefits) {
    if (!benefits?.shadowRoot) return;

    // Commented out to keep Recharge benefits/description in default position
    // and avoid layout shift when switching subscription options.

    /*
    if (benefits.shadowRoot.querySelector('#rhya-benefits-position-style')) return;

    const style = document.createElement('style');
    style.id = 'rhya-benefits-position-style';
    style.textContent = `
      p {
        margin: 0 !important;
      }

      .rc-benefits__list {
        margin-top: -1px !important;
        margin-left: -30px !important;
      }
    `;

    benefits.shadowRoot.appendChild(style);
    */
  }

  function injectOneTimeDrawbacksCSS(drawbacks) {
    if (!drawbacks?.shadowRoot) return;

    // Commented out to keep Recharge one-time drawbacks in default position
    // and avoid layout shift when switching options.

    /*
    if (drawbacks.shadowRoot.querySelector('#rhya-drawbacks-position-style')) return;

    const style = document.createElement('style');
    style.id = 'rhya-drawbacks-position-style';
    style.textContent = `
      .rc-benefits__list {
        margin-left: -30px !important;
      }
    `;

    drawbacks.shadowRoot.appendChild(style);
    */
  }

  function updateOption(option, priceData) {
    const input = option.querySelector('.rc-quantity-upsell-option__input');
    const header = option.querySelector('.rc-quantity-upsell-option__header');
    const priceEl = header?.lastElementChild;

    if (!input || !header || !priceEl) return; 

    const planId = input.value;
    const isOneTime = !planId;

    let totalPrice = priceData.unit;
    let totalComparePrice = '';
    let perMonthPrice = priceData.unit;
    let perMonthComparePrice = '';
    let savePercent = '';
    let saveAmount = ''; 

    if (!isOneTime && priceData.sellingPlans?.[planId]) {
      const plan = priceData.sellingPlans[planId]; 
      const months = getMonths(planId);

      savePercent = `${plan.discountValue}% + free shipping`;
      saveAmount = plan.quantityUpsell?.totalDiscountAmount || '';

      totalPrice = plan.quantityUpsell?.totalDiscountedPrice || plan.price;
      totalComparePrice = formatMoney(getNumber(priceData.unit) * months);

      perMonthPrice = formatMoney(getNumber(totalPrice) / months) + '/mo';
      perMonthComparePrice = priceData.unit;

      const badge = option.querySelector('.rc-purchase-option__plan-discount-badge');
      if (badge && savePercent) badge.textContent = `Save ${savePercent}`;

      const benefits = option.querySelector('rc-benefits'); 
      if (benefits?.shadowRoot) {
        const firstP = benefits.shadowRoot.querySelector('p strong');
        if (firstP) firstP.textContent = `FREE SHIPPING + SAVE ${savePercent}`;

        const recurringDiscountText =
          months === 3
            ? '20% off all recurring orders'
            : '10% off all recurring orders';

        const recurringLine = Array.from(
          benefits.shadowRoot.querySelectorAll('li')
        ).find((li) =>
          li.textContent.toLowerCase().includes('off all recurring orders')
        );

        if (recurringLine) {
          recurringLine.textContent = recurringDiscountText;
        }
      }
    }

    if (!priceEl.querySelector('.rc-custom-price-wrap')) {
      priceEl.innerHTML = `
        <span class="rc-custom-price-wrap">
          <span class="rc-custom-total-price"></span>
          <span class="rc-custom-total-compare-price"></span>
          <span class="rc-custom-per-month-price"></span>
          <span class="rc-custom-compare-price"></span>
        </span>
      `;
    }

    priceEl.querySelector('.rc-custom-total-price').textContent = totalPrice;
    priceEl.querySelector('.rc-custom-total-compare-price').textContent = totalComparePrice;


    priceEl.querySelector('.rc-custom-per-month-price').textContent = perMonthPrice;

    const compareEl = priceEl.querySelector('.rc-custom-compare-price');
    compareEl.textContent = perMonthComparePrice;
    compareEl.style.display = perMonthComparePrice ? 'block' : 'none';

    injectBenefitsCSS(option.querySelector('rc-benefits'));
    injectOneTimeDrawbacksCSS(option.querySelector('rc-onetime-drawbacks'));
  }

  function updateRechargeOptions() {
    const priceData = getPriceData();
    if (!priceData) return;

    const { upsellRoot } = getRechargeRoots();
    if (!upsellRoot) return;

    injectRechargeCSS(upsellRoot);

    upsellRoot.querySelectorAll('.rc-quantity-upsell-option').forEach((option) => {
      updateOption(option, priceData);
    });
  }

  setInterval(updateRechargeOptions, 700);
})();




// The following auto-select code is selecting the 1 Month plan as the default after page load.

// (function () {
//   let autoSelectDone = false;

//   function selectOneMonthPlan() {
//     if (autoSelectDone) return;

//     const widget = document.querySelector('recharge-subscription-widget');
//     if (!widget?.shadowRoot) return;

//     const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
//     if (!upsell?.shadowRoot) return;

//     const root = upsell.shadowRoot;

//     const oneMonthPlanId =
//       window.rhyaRechargeSettings?.oneMonthPlanId || '4670095453';

//     const oneMonthInput = root.querySelector(
//       `input[value="${oneMonthPlanId}"]`
//     );
    
//     if (!oneMonthInput) return;

//     const oneMonthOption = oneMonthInput.closest('.rc-quantity-upsell-option');
//     if (!oneMonthOption) return;

//     if (!oneMonthInput.checked || !oneMonthOption.hasAttribute('rc-selected')) {
//       oneMonthInput.click();
//       oneMonthInput.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
//     }

//     autoSelectDone = true;
//   }

//   const interval = setInterval(selectOneMonthPlan, 300);

//   setTimeout(function () {
//     clearInterval(interval);
//   }, 6000);
// })();










//   =========================================================
//   -------- Custom code ------
//   RHYA Recharge Gift With Purchase
//   ---------------------------------------------------------
//   Adds/removes free gift based on selected Recharge subscription plan.
//   Controlled from theme customizer through window.rhyaRechargeSettings.
//   =========================================================
(function () {
  const SETTINGS = window.rhyaRechargeSettings || {};

  const CONFIG = {
    enableFreeGift: Boolean(SETTINGS.enableFreeGift),
    giftProductHandle: SETTINGS.giftProductHandle || '',
    showForOneMonth: Boolean(SETTINGS.showForOneMonth),
    showForThreeMonth: Boolean(SETTINGS.showForThreeMonth),
    oneMonthPlanId: String(SETTINGS.oneMonthPlanId || ''),
    threeMonthPlanId: String(SETTINGS.threeMonthPlanId || ''),
    giftPropertyName: '_rhya_free_gift',
    giftPropertyValue: 'recharge-subscription-gift',
    colors: {
      accent: '#2A0C14',
      softBackground: '#F5EEE6',
      text: '#2A0C14',
      muted: '#686868',
      border: '#E8DCD1'
    }
  };

  if (!CONFIG.enableFreeGift || !CONFIG.giftProductHandle) return;

  let giftVariantId = null;
  let giftProductData = null;
  let giftProductTitle = null;
  let originalFetch = null;
  let reconcileTimer = null;
  let reconcileRunning = false;
  let cartControlsTimer = null;

  function getNumber(value) {
    return (
      parseFloat(
        String(value || '')
          .replace(/,/g, '')
          .replace(/[^0-9.-]/g, '')
      ) || 0
    );
  }

  function formatMoneyFromCents(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function getRechargeRoots() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot) return {};
    const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!upsell?.shadowRoot) return {};
    return { widget, upsellRoot: upsell.shadowRoot };
  }

  function getRechargeProductId() {
    return Number(
      document
        .querySelector('recharge-subscription-widget')
        ?.getAttribute('product-id') || 0
    );
  }

  function isOneMonthPlanId(planId) {
    return String(planId || '') === CONFIG.oneMonthPlanId;
  }

  function isThreeMonthPlanId(planId) {
    return String(planId || '') === CONFIG.threeMonthPlanId;
  }

  function shouldGiftShowForPlanId(planId) {
    return (
      (CONFIG.showForOneMonth && isOneMonthPlanId(planId)) ||
      (CONFIG.showForThreeMonth && isThreeMonthPlanId(planId))
    );
  }

  function sellingPlanMatchesGiftRule(sellingPlan) {
    const planId = String(sellingPlan?.id || '');
    const planName = String(sellingPlan?.name || '').toLowerCase();

    const oneMonthMatch =
      CONFIG.showForOneMonth &&
      (isOneMonthPlanId(planId) ||
        planName.includes('1 month') ||
        planName.includes('one month'));

    const threeMonthMatch =
      CONFIG.showForThreeMonth &&
      (isThreeMonthPlanId(planId) ||
        planName.includes('3 month') ||
        planName.includes('three month'));

    return oneMonthMatch || threeMonthMatch;
  }

  async function getGiftVariantId() {
    if (giftVariantId && giftProductData) return giftVariantId;

    const response = await originalFetch(
      `/products/${CONFIG.giftProductHandle}.js`,
      { credentials: 'same-origin' }
    );

    if (!response.ok) return null;

    const product = await response.json();
    const availableVariant =
      product.variants?.find((variant) => variant.available) ||
      product.variants?.[0];

    giftProductData = product;
    giftProductTitle = product.title || null;
    giftVariantId = availableVariant?.id || null;

    return giftVariantId;
  }

  function isQualifyingSubscriptionLine(line, rechargeProductId) {
    if (Number(line.product_id) !== rechargeProductId) return false;
    if (!line.selling_plan_allocation?.selling_plan) return false;

    return sellingPlanMatchesGiftRule(line.selling_plan_allocation.selling_plan);
  }

  function isAutoGiftLine(line) {
    return line.properties?.[CONFIG.giftPropertyName] === CONFIG.giftPropertyValue;
  }

  function notifyCartChanged(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart }
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart }
      })
    );
  }

  async function reconcileFreeGift() {
    if (reconcileRunning || !originalFetch) return;

    const rechargeProductId = getRechargeProductId();
    if (!rechargeProductId) return;

    reconcileRunning = true;

    try {
      const cartResponse = await originalFetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const qualifies = cart.items.some((line) =>
        isQualifyingSubscriptionLine(line, rechargeProductId)
      );
      const autoGiftLines = cart.items.filter(isAutoGiftLine);

      if (autoGiftLines[0]?.product_title) {
        giftProductTitle = autoGiftLines[0].product_title;
      }

      if (qualifies && autoGiftLines.length === 0) {
        const variantId = await getGiftVariantId();
        if (!variantId) return;

        const addResponse = await originalFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  [CONFIG.giftPropertyName]: CONFIG.giftPropertyValue
                }
              }
            ]
          })
        });

        if (!addResponse.ok) return;
      }

      if (qualifies && autoGiftLines.length > 1) {
        for (const duplicateGift of autoGiftLines.slice(1)) {
          await originalFetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: duplicateGift.key,
              quantity: 0
            })
          });
        }
      }

      if (!qualifies && autoGiftLines.length > 0) {
        for (const autoGift of autoGiftLines) {
          await originalFetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: autoGift.key,
              quantity: 0
            })
          });
        }
      }

      if (
        (qualifies && autoGiftLines.length !== 1) ||
        (!qualifies && autoGiftLines.length > 0)
      ) {
        const updatedCartResponse = await originalFetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (updatedCartResponse.ok) {
          notifyCartChanged(await updatedCartResponse.json());
        }
      }
    } catch (error) {
      console.warn('Rhya free gift could not be synchronized.', error);
    } finally {
      reconcileRunning = false;
    }
  }

  function scheduleGiftReconcile(delay = 50) {
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(reconcileFreeGift, delay);
  }

  function watchCartRequests() {
    if (originalFetch || !window.fetch) return;

    originalFetch = window.fetch.bind(window);

    window.fetch = async function (...args) {
      const response = await originalFetch(...args);
      const requestUrl =
        typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(requestUrl)) {
        scheduleGiftReconcile(50);
      }

      return response;
    };

    getGiftVariantId();
    scheduleGiftReconcile(100);
  }

  function injectGiftCSS(root) {
    if (!root || root.querySelector('#rhya-recharge-gwp-style')) return;

    const style = document.createElement('style');
    style.id = 'rhya-recharge-gwp-style';
    style.textContent = `
      .rhya-free-gift {
        margin-top: 12px !important;
        padding: 12px !important;
        border: 1px solid ${CONFIG.colors.border} !important;
        border-radius: 10px !important;
        background: ${CONFIG.colors.softBackground} !important;
        color: ${CONFIG.colors.text} !important;
      }

      .rhya-free-gift__teaser {
        display: flex !important;
        align-items: center !important;
        gap: 9px !important;
        font-size: 13px !important;
        line-height: 1.3 !important;
      }

      .rhya-free-gift__teaser-image {
        width: 34px !important;
        height: 34px !important;
        flex: 0 0 34px !important;
        border-radius: 6px !important;
        object-fit: cover !important;
      }

      .rhya-free-gift__full {
        display: none !important;
        align-items: center !important;
        gap: 12px !important;
      }

      .rhya-free-gift__image {
        width: 72px !important;
        height: 72px !important;
        flex: 0 0 72px !important;
        border-radius: 8px !important;
        object-fit: cover !important;
      }

      .rhya-free-gift__body {
        display: flex !important;
        flex-direction: column !important;
        gap: 5px !important;
      }

      .rhya-free-gift__title {
        font-size: 13px !important;
        line-height: 1.3 !important;
      }

      .rhya-free-gift__prices {
        display: flex !important;
        align-items: center !important;
        gap: 7px !important;
        font-size: 14px !important;
        line-height: 1.2 !important;
      }

      .rhya-free-gift__free-price {
        color: ${CONFIG.colors.accent} !important;
        font-weight: 700 !important;
      }

      .rhya-free-gift__compare-price {
        color: #8A7D75 !important;
        text-decoration: line-through !important;
      }

      .rc-quantity-upsell-option[rc-selected] .rhya-free-gift {
        background: ${CONFIG.colors.accent} !important;
        border-color: ${CONFIG.colors.accent} !important;
        color: #FFFFFF !important;
      }

      .rc-quantity-upsell-option[rc-selected] .rhya-free-gift__teaser {
        display: none !important;
      }

      .rc-quantity-upsell-option[rc-selected] .rhya-free-gift__full {
        display: flex !important;
      }

      .rc-quantity-upsell-option[rc-selected] .rhya-free-gift__free-price {
        color: #FFFFFF !important;
      }

      .rc-quantity-upsell-option[rc-selected] .rhya-free-gift__compare-price {
        color: rgba(255, 255, 255, 0.75) !important;
      }

      @media (max-width: 600px) {
        .rhya-free-gift__image {
          width: 62px !important;
          height: 62px !important;
          flex-basis: 62px !important;
        }

        .rhya-free-gift {
          padding: 10px !important;
        }
      }
    `;

    root.appendChild(style);
  }

  function createGiftPanel() {
    const panel = document.createElement('div');
    panel.className = 'rhya-free-gift';
    panel.innerHTML = `
      <div class="rhya-free-gift__teaser">
        <img class="rhya-free-gift__teaser-image" alt="">
        <span class="rhya-free-gift__teaser-text"></span>
      </div>
      <div class="rhya-free-gift__full">
        <img class="rhya-free-gift__image" alt="">
        <div class="rhya-free-gift__body">
          <div class="rhya-free-gift__title"></div>
          <div class="rhya-free-gift__prices">
            <span class="rhya-free-gift__free-price">$0.00</span>
            <span class="rhya-free-gift__compare-price"></span>
          </div>
        </div>
      </div>
    `;

    return panel;
  }

  async function updateGiftPanel(option, contentContainer) {
    let panel = contentContainer.querySelector('.rhya-free-gift');

    if (!panel) {
      panel = createGiftPanel();
      contentContainer.appendChild(panel);
    }

    if (!giftProductData) {
      await getGiftVariantId();
    }

    if (!giftProductData) return;

    const variant =
      giftProductData.variants?.find((item) => item.available) ||
      giftProductData.variants?.[0];
    const title = giftProductData.title || 'Free gift';
    const image =
      variant?.featured_image?.src ||
      giftProductData.featured_image ||
      giftProductData.images?.[0] ||
      '';


    const productPrice = Number(variant?.price || 0);
    const compareAtPrice = Number(variant?.compare_at_price || 0);

    const displayComparePrice =
      compareAtPrice > productPrice ? compareAtPrice : productPrice;

    panel.querySelectorAll('img').forEach((imageElement) => {
      imageElement.src = image;
      imageElement.alt = title;
    });

    panel.querySelector('.rhya-free-gift__teaser-text').innerHTML =
      `<strong>+ FREE GIFT:</strong> ${title}`;

    panel.querySelector('.rhya-free-gift__title').innerHTML =
      `<strong>FREE ${title}</strong>`;

    const comparePriceEl = panel.querySelector('.rhya-free-gift__compare-price');

    if (displayComparePrice > 0) {
      comparePriceEl.style.display = '';
      comparePriceEl.textContent = formatMoneyFromCents(displayComparePrice);
    } else {
      comparePriceEl.style.display = 'none';
    }


  }

  function updateGiftPanels() {
    const { upsellRoot } = getRechargeRoots();
    if (!upsellRoot) return;

    injectGiftCSS(upsellRoot);

    upsellRoot.querySelectorAll('.rc-quantity-upsell-option').forEach((option) => {
      const input = option.querySelector('input[name="quantityUpsellOption"], .rc-quantity-upsell-option__input');
      const planId = String(input?.value || '');
      const contentContainer = option.querySelector('.rc-quantity-upsell-option__content-container');

      if (!contentContainer) return;

      if (shouldGiftShowForPlanId(planId)) {
        updateGiftPanel(option, contentContainer);
      } else {
        contentContainer.querySelector('.rhya-free-gift')?.remove();
      }
    });
  }

  function hideRechargeGiftControls() {
    const cartDrawer = document.querySelector('#recharge-storefront-experiences__cart-drawer');
    const root = cartDrawer?.shadowRoot;

    if (!root) return;

    root.querySelectorAll('[role="listitem"]').forEach((lineItem) => {
      const title = lineItem.querySelector('p.font-semibold')?.textContent.trim();
      const titleMatches = giftProductTitle && title === giftProductTitle;
      const hasFreePrice = Array.from(lineItem.querySelectorAll('[part~="discount"]')).some(
        (element) => getNumber(element.textContent) === 0
      ); 

      if (!titleMatches && !hasFreePrice) return;

      const quantityInput = lineItem.querySelector('input[name="quantity"]');
      const quantityControls = quantityInput?.parentElement;
      const removeButton = Array.from(lineItem.querySelectorAll('button')).find((button) =>
        button
          .querySelector('.sr-only')
          ?.textContent.trim()
          .toLowerCase()
          .startsWith('remove ')
      );

      if (quantityControls) {
        quantityControls.style.setProperty('display', 'none', 'important');
      }

      if (removeButton) {
        removeButton.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function watchRechargeGiftControls() {
    if (cartControlsTimer) return;
    cartControlsTimer = window.setInterval(hideRechargeGiftControls, 500);
  }

  function initializeGiftLogic() {
    watchCartRequests();
    updateGiftPanels();
    watchRechargeGiftControls();
  }

  setInterval(updateGiftPanels, 700);

  document.addEventListener('DOMContentLoaded', initializeGiftLogic);
  document.addEventListener('shopify:section:load', initializeGiftLogic);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'input[name="quantityUpsellOption"], .rc-quantity-upsell-option__input, form[action*="/cart/add"] [name="id"]'
      )
    ) {
      setTimeout(updateGiftPanels, 50);
      scheduleGiftReconcile(250);
    }
  });
})();




//   =========================================================
//   -------- Custom code ------
//   Code fix for streched product image in the recharge cart drawer
//   =========================================================
(function() {

  function fixRechargeCartImages() {
    const host = document.querySelector('#recharge-storefront-experiences__cart-drawer');

    if (!host?.shadowRoot) return;

    host.shadowRoot.querySelectorAll('#cart-drawer img').forEach((img) => { 
      img.style.objectFit = 'cover';
      img.style.height = 'auto';
    });
  }

  setInterval(fixRechargeCartImages, 1000);

})();







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();







